<template functional>
	<article :class="[data.class, data.staticClass]">
		<div class="space-y-24 tabletWide:space-y-32">
			<div class="col-span-12 font-bold text-24 tablet:text-32">
				<span class="text-goPink">GO rentals</span> <br />
				<h2>Affordable {{ props.name }} Car Hire</h2>
			</div>

			<div class="space-y-24 tabletWide:space-y-32">
				<dl v-if="props.phone">
					<dt class="text-14">Branch landline</dt>
					<dd class="font-bold">
						<a :href="'tel:' + props.phone" class="text-goBlack hover:text-goPinkDark active:text-goPinkDarker">{{ props.phone }}</a>
					</dd>
				</dl>
				<dl v-if="props.email">
					<dt class="text-14">Branch email</dt>
					<dd class="font-bold text-goBlue hover:text-goPink">
						<a :href="'mailto:' + props.email" class="text-goBlack hover:text-goPinkDark active:text-goPinkDarker">{{ props.email }}</a>
					</dd>
				</dl>
				<dl v-if="props.address">
					<dt class="text-14">Branch address</dt>
					<dd class="font-bold text-goBlue hover:text-goPink">
						<a :href="'https://www.google.com/maps?q=' + props.address" rel="noopener" target="_blank" class="link link-goBlack">{{ props.address }}</a>
					</dd>
				</dl>
			</div>

			<hr v-if="props.pickUpAndDropOff" class="border-black/10" />

			<div class="space-y-24 tabletWide:space-y-32">
				<dl v-if="props.pickUpAndDropOff">
					<dt class="text-14">Pick-up & Drop-off</dt>
					<dd class="font-bold">{{ props.pickUpAndDropOff }}</dd>
				</dl>
				<dl v-if="props.openingTime && props.closingTime">
					<dt class="text-14">Office open hours</dt>
					<dd class="font-bold">{{ props.openingTime }} - {{ props.closingTime }}, 7 days a week.</dd>
				</dl>
				<dl v-if="props.shuttleOperatingHours">
					<dt class="text-14">Shuttle operating hours</dt>
					<dd class="font-bold">{{ props.shuttleOperatingHours }}</dd>
				</dl>

				<div v-if="props.faqs.length" class="space-y-16">
					<p v-for="(faq, index) in props.faqs" :key="'faq' + index">
						<nuxt-link :to="faq.url" class="text-goBlue hover:text-goPink flex space-x-8">
							<svg-icon name="help" class="iconSize-24" />
							<span>{{ faq.question }}</span>
						</nuxt-link>
					</p>
				</div>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			default: "",
		},
		phone: {
			type: String,
			default: "",
		},
		freePhone: {
			type: String,
			default: "",
		},
		email: {
			type: String,
			default: "",
		},
		openingTime: {
			type: String,
			default: "",
		},
		closingTime: {
			type: String,
			default: "",
		},
		pickUpAndDropOff: {
			type: String,
			default: "",
		},
		shuttleOperatingHours: {
			type: String,
			default: "",
		},
		faqs: {
			type: Array,
			default: () => [],
		},
		contentLinks: {
			type: Array,
			default: () => [],
		},
		address: {
			type: String,
			default: "",
		},
		path: {
			type: String,
			default: "",
		},
	},
}
</script>
